import React, { useEffect, useState } from "react";

const ZOLA_URL = "https://www.zola.com/registry/laurenandowenseptember6";

const Registry: React.FC = () => {
  const [secondsLeft, setSecondsLeft] = useState(5);

  // tick the countdown every second
  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft((s) => s - 1);
    }, 1000);
    return () => clearInterval(id); // cleanup on unmount
  }, []);

  // when countdown hits 0, redirect
  useEffect(() => {
    if (secondsLeft === 0) {
      window.location.href = ZOLA_URL;
    }
  }, [secondsLeft]);

  return (
    <div className="text-content">
      <div className="simple-card">
        <h2>
          Heading to our registry in {secondsLeft} second
          {secondsLeft !== 1 && "s"}…
        </h2>
        <p>
          If it doesn’t open automatically,{" "}
          <a href={ZOLA_URL} target="_blank" rel="noopener noreferrer">
            click here to visit our Zola registry
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Registry;
